import { action, computed, makeObservable, observable } from 'mobx';
import processIncomingData from '../processIncomingData';
import WorkTime from '../models/workTime';
import * as utils from '../../helpers/utils';

class WorkTimeStore {
  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @observable workTimes = [];

  @computed get getFormattedWorkTime() {
    return this.workTimes
      .filter((f) => f.IsEnabled)
      .slice()
      .sort((a, b) => utils.daySorter[a.Day.toLowerCase()] - utils.daySorter[b.Day.toLowerCase()])
      .map((m) => `${m.Day} - ${m.Open} - ${m.Closed}`);
  }

  @action UpsertAndGet(incObj) {
    return processIncomingData(incObj, this.rootStore, this.workTimes, WorkTime);
  }
}

export default WorkTimeStore;
